module.exports = __webpack_public_path__ + "media/yi7.0afd2367.mp4";